import { SECURE_URL_PREFIX, AMAZON_CONSOLE_LINK } from './constants';

export const getAccessLink = identificator =>
    identificator ? `${SECURE_URL_PREFIX}${identificator}.signin.aws.amazon.com/console/` : AMAZON_CONSOLE_LINK;
